import React from 'react'

export default function Video() {
  return (
    <iframe 
      width="560" 
      height="315" 
      src="https://youtube.com/embed/qLDAnFip0m0" 
      title="Martz Training Video" 
      frameBorder="0" 
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
      allowFullScreen
    />
  )
}